import { useLoadingIndicatorStore } from "@/lib/store/use-loading-indicator-store";
import { createPortal } from "react-dom";
import { CommonLoading } from "./common-loading";

interface LoadingIndicatorProps {
  className?: string;
}

export function LoadingIndicator({ className }: LoadingIndicatorProps) {
  const { loading } = useLoadingIndicatorStore();

  if (!loading) {
    return null;
  }

  return createPortal(<CommonLoading className={className} />, document.body);
}
